"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttleFactory = void 0;
const http_interfaces_1 = require("../types/http.interfaces");
const time_management_1 = require("./time-management");
const throttleFactory = (globalContext, endpointPromise, throttleMap) => {
    let history;
    let throttlePolicy;
    // wait for endpoint model to initialize and then set history space from either
    // - local history array
    // - or share it from throttleMap with other endpoints when throttleKey is defined
    endpointPromise.then((endpoint) => {
        if (endpoint.throttlePolicy) {
            throttlePolicy = endpoint.throttlePolicy;
            const throttleKey = throttlePolicy?.throttleKey;
            if (throttleKey) {
                history = throttleMap.get(throttleKey) || [];
                if (!throttleMap.has(throttleKey)) {
                    throttleMap.set(throttleKey, history);
                }
            }
            else {
                history = [];
            }
        }
    });
    // Only return throttle wrapper when Throttle policy is defined. Otherwise return an original send
    return (httpSend) => !throttlePolicy
        ? httpSend
        : (request) => {
            function send(request) {
                history.push(Date.now());
                return httpSend(request);
            }
            async function executeRequest(request) {
                const waitNeeded = expectedWaitTime(history, throttlePolicy);
                if (!waitNeeded) {
                    return send(request);
                }
                const logStep = request.operationLogger.logStep(http_interfaces_1.OperationLogEntryType.Throttle);
                await (0, time_management_1.sleep)(waitNeeded, globalContext);
                logStep && logStep({ result: http_interfaces_1.Status[http_interfaces_1.Status.OK] });
                return executeRequest(request);
            }
            return executeRequest(request);
        };
};
exports.throttleFactory = throttleFactory;
/**
 * Calculates time request should wait to meet throttling rules - logged request count becomes less
 * than maximum number of request per interval.
 * Returns 0 if waiting is not needed.
 */
function expectedWaitTime(history, throttlePolicy) {
    const { maxPerThrottleInterval, throttleInterval } = throttlePolicy;
    const startTime = Date.now() - throttleInterval;
    let i = history.length - 1;
    while (i >= 0 && startTime < history[i]) {
        i--;
    }
    history.splice(0, i);
    const waitIndex = history.length - maxPerThrottleInterval;
    return waitIndex >= 0 ? history[waitIndex] - startTime : 0;
}
